"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Submit =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Submit, _PureComponent);

  function Submit(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Submit.prototype;

  _proto.handleClick = function handleClick(e) {
    var _this2 = this;

    e.persist();
    setTimeout(function () {
      _this2.props.onSubmit(e.target);
    }, 50);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        onSubmit = _this$props.onSubmit,
        loading = _this$props.loading,
        children = _this$props.children,
        formStatus = _this$props.formStatus,
        other = _objectWithoutPropertiesLoose(_this$props, ["onSubmit", "loading", "children", "formStatus"]);

    return _react.default.createElement(_Button.default, _extends({
      type: "primary"
    }, other, {
      disabled: other.disabled || formStatus === 'disabled',
      loading: formStatus === 'pending' || loading,
      onClick: this.handleClick
    }), children);
  };

  return Submit;
}(_react.PureComponent);

Submit.propTypes = {
  children: _propTypes.default.any,
  formStatus: _propTypes.default.string,
  loading: _propTypes.default.bool,
  onCollapse: _propTypes.default.func,
  onSubmit: _propTypes.default.func
};
var _default = Submit;
exports.default = _default;